'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = 'M368 96c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 3.6c0 6.9 5.6 12.4 12.4 12.4l135.1 0c6.9 0 12.4-5.6 12.4-12.4l0-3.6zM192 96c0-53 43-96 96-96s96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6zM432 280c0-48.6-39.4-88-88-88l-112 0c-48.6 0-88 39.4-88 88l0 72c0 76.8 60.2 139.6 136 143.8L280 264c0-4.4 3.6-8 8-8s8 3.6 8 8l0 231.8c75.8-4.2 136-66.9 136-143.8l0-72zm-16.6-75.6c20.1 19 32.6 45.8 32.6 75.6l120 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-120 0 0 56c0 14-1.8 27.6-5.2 40.5 .7 .3 1.4 .6 2 1.1l96 72c3.5 2.6 4.2 7.7 1.6 11.2s-7.7 4.2-11.2 1.6l-93.4-70.1C415 468.9 356.5 512 288 512S161 468.9 138.2 408.3L44.8 478.4c-3.5 2.6-8.5 1.9-11.2-1.6s-1.9-8.6 1.6-11.2l96-72c.6-.5 1.3-.8 2-1.1-3.4-12.9-5.2-26.5-5.2-40.5l0-56-120 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l120 0c0-29.8 12.5-56.6 32.6-75.6l-125.4-94c-3.5-2.7-4.3-7.7-1.6-11.2s7.7-4.3 11.2-1.6l128.6 96.5C190.1 182.7 210.3 176 232 176l112 0c21.7 0 41.9 6.7 58.6 18.1L531.2 97.6c3.5-2.7 8.6-1.9 11.2 1.6s1.9 8.5-1.6 11.2l-125.4 94z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;